import {chain} from 'lodash';

import {ApiConversationJoinBatch} from '../../models/api/conversationJoinBatchModel';
import {mergeDataGroups} from '../../models/api/dataGroupModel';
import {ThunkAsyncAction} from '../../store/appThunk';
import {getCompany} from '../../store/data/company/companySelectors';
import {updateDataAction} from '../../store/data/dataGroupsActions';
import {postApiAsync} from '../http/http';
import {lockAllAsync} from '../locks/lock';
import {findConversationLock} from '../locks/resourceLocks';

export function mergeConversationsAsyncAction(
  conversationIds: ReadonlyArray<number>,
): ThunkAsyncAction<number> {
  return async (dispatch, getState) => {
    // Acquire locks for affected conversations, since the API request is not idempotent. Sort them to avoid deadlocks.
    // https://front.atlassian.net/browse/PB-31385
    const conversationLocks = chain(conversationIds)
      .sortBy()
      .map((id) => findConversationLock(id))
      .value();

    return lockAllAsync(conversationLocks, async () => {
      // Perform the request.
      const company = getCompany(getState());
      const url = `${company.url}/conversation_batch/join?return_conversations=true`;
      const body = {conversation_ids: conversationIds};
      const {electedConversationId, dataGroups} = await postApiAsync(ApiConversationJoinBatch, url, body);

      // Update the store.
      const dataGroup = mergeDataGroups(...dataGroups);
      // TODO: Should we delete all conversations except the one that was elected, like we do in response to the
      // conversations_joined push event?
      dispatch(updateDataAction(dataGroup));

      return electedConversationId;
    });
  };
}
